/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Firm } from '../models/firm';
import { getFirms } from '../fn/firm/get-firms';
import { GetFirms$Params } from '../fn/firm/get-firms';

@Injectable({ providedIn: 'root' })
export class FirmService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFirms()` */
  static readonly GetFirmsPath = '/api/firms';

  /**
   * Select list of active firms with all active departments belonging to the firm.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFirms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFirms$Response(params?: GetFirms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Firm>>> {
    return getFirms(this.http, this.rootUrl, params, context);
  }

  /**
   * Select list of active firms with all active departments belonging to the firm.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFirms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFirms(params?: GetFirms$Params, context?: HttpContext): Observable<Array<Firm>> {
    return this.getFirms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Firm>>): Array<Firm> => r.body)
    );
  }

}
